import type { FaireProductEntity } from "../../entity_types/product";

export const p_aavytyx9ss: FaireProductEntity = {
  token: "p_aavytyx9ss",
  type: "product",
  name: "Happy Plaid Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/03be828af5467f350eb870afac505ed379c59ed854469db0a000a3434759ddea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0241368a96ea320212f6175dda51f811656d1c760da079eac6a0e147beb81e2a.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "We're mad for plaid and glad to be fully clad, just like our dad.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:56.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
